<template>
  <!-- Search bar-->
  <form class="search-form">
    <div class="relative max-w-fit-content">
      <input
        class="search-input max-w-[990px] w-[990px] rounded-[25px] bg-white appearance-none focus:outline-none placeholder-italic text-base leading-tight ml-0 md:ml-1 placeholder-[hsla(223,5%,73%,1)]"
        type="text"
        placeholder="Search the Geeq blockchain"
        v-model="searchStr"
      >
      <button v-on:keyup.prevent.enter="search" @click.prevent="search" 
      class="search-btn bg-blue-light absolute right-[4px] top-[4px]" :class="{'search-btn--loading': isLoadingInProgress}">
        <div v-if="isLoadingInProgress" class="flex items-center justify-center">
          <Loader color="#FFFFFF" width="20px" height="20px" />
        </div>
        <span v-else>
          Search
        </span>
      </button>
    </div>

  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Loader from '@/components/common/Loader.vue';

export default {
  name: "SearchForm",
  components: {
    Loader,
  },
  computed: {
    ...mapState({
      isLoadingInProgress: state => state.isLoadingInProgress,
    }),
    // ...mapGetters({
    //     isLoadingInProgress: 'getIsLoadingInProgress',
    // }),
  },
  data: () => {
    return {
      searchStr: '',
    }
  },
  methods: {
    search() {
      if (this.isLoadingInProgress) {
        return;
      }
      this.$store.dispatch('searchBlockchain', this.searchStr);
    }
  }
}
</script>

<style scoped>

</style>
